// Copyright (c) 2016 Deere & Company

import accountLookup from './account-lookup';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import dealerSearchModal from './dealer-search-modal';
import isAmountOfUseModalOpen from './amount-of-use-modal-visibility';
import newTransfer from './new-transfer';
import newTransferStatusChangeModal from './new-transfer-status-change-modal';
import product from './product';

export default {
    createTransfer: combineReducers({
        accountLookup,
        busyCounter,
        dealerSearchModal,
        isAmountOfUseModalOpen,
        newTransfer,
        newTransferStatusChangeModal,
        product
    })
};



// WEBPACK FOOTER //
// ./src/product/new-transfer/reducers/index.js